/**
 * @module Theme
 */

import { Component, Input, OnInit } from '@angular/core';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ItemColor } from '@functions/item.functions';
import { ChartType } from '@models/chart.model';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-axes-category-percentage',
  templateUrl: './theme-option-axes-category-percentage.component.html',
  styleUrls: ['./theme-option-axes-category-percentage.component.css']
})
export class ThemeOptionAxesCategoryPercentageComponent implements OnInit {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() axesIndex: number;
  @Input() axesXY: 'x' | 'y';

  showDetails: boolean;
  color = ItemColor('themes');
  optionType: ThemeOptionType = 'axes_categoryPercentage';
  limitedTo: ChartType[];

  constructor() {
    this.showDetails = false;
  }

  ngOnInit() {
    this.limitedTo = this.axesXY === 'x' ? ['bar'] : ['horizontalBar'];
  }

  receiveValue(value: number, type?: ChartType) {
    this.themeOptions.setAxes(this.optionType, value / 100, this.axesXY, this.axesIndex, type ? [type] : undefined);
  }

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

}
